// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2iKWO","rootSmall":"AddTileButton_rootSmall__2WsHy"};